/**
 * Created by zzy on 2019/8/5.
 */
import SystemLogs from './SystemLogs.vue'
export default SystemLogs



// WEBPACK FOOTER //
// ./src/views/events/SystemLogs/index.js